import updateExerciseAction from 'modules/training/modules/training-exercises/actions/update'
import { EXERCISE_KEY } from 'modules/training/models/exercise/constants'

function updateMusclesExerciseAction (instance, value) {
  return updateExerciseAction({
    key: EXERCISE_KEY.MUSCLES,
    value,
    instance
  })
}

export default updateMusclesExerciseAction
